import { Stack, Redirect, useSegments } from "expo-router";
import { useAuth } from "@/context/AuthContext";
import { getVendorRouteGuardRedirect } from "@/lib/authRedirect";

/**
 * Vendor route group — guards against non-vendors and redirects
 * vendors to the correct screen based on their current status.
 */
export default function VendorLayout() {
  const segments = useSegments();
  const { isAuthenticated, isLoading, user, hasDismissedPendingReview } = useAuth();

  if (isLoading) return null;

  if (!isAuthenticated || !user) {
    return <Redirect href="/(auth)/login" />;
  }

  if (user.temporaryPasswordSet) {
    return <Redirect href="/(auth)/change-password" />;
  }

  if (!user.roles.includes("vendor")) {
    return <Redirect href="/(auth)/login" />;
  }

  // Enforce vendor-status-based routing to prevent deep-link bypasses.
  // segments[1] is the sub-route within the (vendor) group.
  const currentSub = (segments as string[])[1] as string | undefined;
  const status = user.vendorStatus;

  const guardRedirect = getVendorRouteGuardRedirect(status, currentSub, hasDismissedPendingReview);
  if (guardRedirect) {
    return <Redirect href={guardRedirect} />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
